<template>
    <div>
         
           <div class="card page mb-5 p-2" style="width:1300px;margin:0 auto;box-shadow: 10px 10px 5px #888888;" id="v-content">
             <p>
                  <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                  </span>
             </p>
            <div style="margin:0 auto;width:1000px;">
                  <select v-model="bumen" style="width:200px;margin-bottom:20px;" @click="Getbmpj()" class="form-control">
                                                          <option value="">请选择部门</option>
                                                          <option v-for="(item,index) in options" :key="index" :value="item.departmentname" v-text="item.departmentname" ></option>
                 </select>
                   <table class="table table-striped table-hover">
                        <tr class="text-center" style="font-size:20px;">
                            <th>部门名称</th>
                            <th>评分</th>
                            <th>评价人</th>
                            <th>评价时间</th>
                            <th>说明</th>
                        </tr>
                        <tr v-for="(item,index) in pjList" :key="index" class="text-center">
                            <td style="vertical-align:middle;font-size:15px;">{{item.bumenname}}</td>
                            <td style="color:red;">
                                 {{item.pf}}分
                                  <!-- <rater class="diy-box" :score="item.pf"></rater> -->
                            </td>
                            <td style="vertical-align:middle">{{item.adduser}}</td>
                            <td style="vertical-align:middle">{{item.inserttime}}</td>
                            <td style="vertical-align:middle">{{item.context}}</td>
                        </tr>
                   </table>
                   <P class="mb-5 text-right" style="font-size:20px;">
                         
                       
                         <span class="mr-5">
                             <span style="color:green;">
                                 {{sumpeople}}
                             </span>
                             人评价
                         </span>
                         <span>
                            合计分:
                         </span>
                         <span class="mr-5" style="color:red;font-size:25px;">
                           {{sumpf}}分
                         </span>
                        <span>
                            平均分:
                        </span>
                        <span style="color:red;font-size:30px;">
                            {{pjf}}分
                        </span>
                   </P>
            </div>
       </div>

    </div>
</template>

<script>
import rater from "w-rater";
export default {
    data(){
        return {
           pjList:[],
           bumen:"",
           options:[],
           pjf:"",
           sumpf:"",
           sumpeople:""
        }
    },
    components:{
        rater,
    },
    methods:{

         //获取下发部门
           GetBumen:async function(){
          const { data: res } = await this.$http.get('Dls/GetBumen2', {
           })
            // console.log(res)
           if(res.isok){
            //  console.log(res.data)
               this.options=res.data
           }

          },

           //获取部门评价
        Getbmpj:async function () {
               const that=this
               await that.$http.post('Dls/Getbmpj',{    
                  pageIndex:"1",
                  bumenname:that.bumen
               }).then(res=>{
                //   console.log(res)
                  if(res.data.isok){ 
                       that.pjList=res.data.data;
                       that.sumpf=res.data.sumpf;
                       that.sumpeople=res.data.sumpeople;
                       let Numbers=0;
                       that.pjList.forEach(item=>{
                            Numbers+=item.pf
                           
                       })
                      that.pjf=Number(Numbers/that.pjList.length).toFixed(2);
                    
                       

                  }

               })
        },
             

    },
    created(){
      this.GetBumen();
      this.Getbmpj();
    }
}
</script>

<style scoped>


</style>





// WEBPACK FOOTER //
// src/pages/Pj/Evaluate.vue